import { gql } from "@apollo/client";

export const CUSTOM_VIEW_PERMISSIONS_FIELDS = gql`
  fragment CustomViewPermissionsFields on CustomViewPermissions {
    canRename
    canChangeVisibility
    canChangeLayout
    canDelete
    canSaveFilters
    canDuplicate
    isCreator
    isMigrated
  }
`;

export const CUSTOM_VIEW_FIELDS = gql`
  fragment CustomViewFields on CustomView {
    _id
    name
    module
    type: viewType
    visibility
    filters
    sort
    layout {
      boardGroupBy
      columns
    }
    createdBy
    isPersonal
    permissions {
      ...CustomViewPermissionsFields
    }
  }
  ${CUSTOM_VIEW_PERMISSIONS_FIELDS}
`;

export const USER_VIEW_PREFERENCE_FIELDS = gql`
  fragment UserViewPreferenceFields on UserViewPreference {
    module
    viewOrder
    activeViewId
  }
`;
